<template>
  <!--<header :class="{ 'scrolled-nav': scrollNav}">-->
  <header>
  
    <nav>

<!--VERSION DESKTOP ================================================================================================================================================================================-->

        <div v-show="!mobile" class="branding" style="margin-top: 10px;">
            <img src="../../../assets/logo.png">
            <img src="../../../assets/menuIcons/blue/vLine.png">
        </div>
        
        <ul v-show="!mobile" class="navigation">
            <!--ACCUEIL-->
            <li><router-link class='home' :to="{ name: 'accueil'}">Accueil</router-link></li>
            <!--VENTE-->
            <li><a class='prett' href='' title=''>Vente</a><b-icon :icon="'chevron-down'" :variant="getTheme.light" font-scale="0.8"></b-icon>
            <ul class='menus'>
                <li><router-link class='home' :to="{ name: 'invoice'}">Factures</router-link></li>
                <li><a href='#' title=''>Commande*</a></li>
                <li><a href='#' title=''>Soumission*</a></li>
            </ul>
            </li>
            <!--CLIENTS-->
            <li><a class='prett' href='#' title=''>Client</a><b-icon :icon="'chevron-down'" :variant="getTheme.light" font-scale="0.8"></b-icon>
            <ul class='menus'>
                <li><router-link class='home' :to="{ name: 'clientAccount'}">Fiches client</router-link></li>
                <li><router-link class='home' :to="{ name: 'client.contacts'}">Contacts</router-link></li>
                <li><a href='#' title=''>Paiements*</a></li>
                <li><a href='#' title=''>Ententes de paiement*</a></li>
            </ul>
            </li>
            <!--INVENTAIRE-->
            <li><a class='prett' href='' title=''>Inventaire</a><b-icon :icon="'chevron-down'" :variant="getTheme.light" font-scale="0.8"></b-icon>
            <ul class='menus'>
                <li><router-link class='home' :to="{ name: 'items'}">Items</router-link></li>
                <li><router-link class='home' :to="{ name: 'department'}">Département</router-link></li>
                <li><router-link class='home' :to="{ name: 'category'}">Catégories</router-link></li>
                <li><a href='#' title=''>Ajustement*</a></li>
            </ul>
            </li>
            <!--ACHAT-->
            <li><a class='prett' href='' title=''>Achat</a><b-icon :icon="'chevron-down'" :variant="getTheme.light" font-scale="0.8"></b-icon>
            <ul class='menus'>
                <li><a href='#' title=''>Achats*</a></li>
                <li><a href='#' title=''>Réceptions*</a></li>
            </ul>
            </li>
            <!--FOURNISSEUR-->
            <li><a class='prett' href='' title=''>Fournisseur</a><b-icon :icon="'chevron-down'" :variant="getTheme.light" font-scale="0.8"></b-icon>
            <ul class='menus'>
                <li><router-link class='home' :to="{ name: 'supplier'}">Fournisseurs</router-link></li>
                <li><router-link class='home' :to="{ name: 'supplier.contacts'}">Contacts</router-link></li>
                <li><a href='#' title=''>Paiements*</a></li>
            </ul>
            </li>
            <!--COMPTABILITÉ-->
            <li><a class='prett' href='' title=''>Comptabilité</a><b-icon :icon="'chevron-down'" :variant="getTheme.light" font-scale="0.8"></b-icon>
            <ul class='menus'>
                <li><router-link class='home' :to="{ name: 'account'}">Comptes</router-link></li>
                <li><router-link class='home' :to="{ name: 'exercises'}">Exercices</router-link></li>
                <li><router-link class='home' :to="{ name: 'inscription'}">Inscription</router-link></li>
                <li><router-link class='home' :to="{ name: 'transactions'}">Transaction</router-link></li>
                <li><a href='#' title=''>Conciliations*</a></li>
                <li><a href='#' title=''>Chèques*</a></li>
            </ul>
            </li>
            <!--RAPPORTS-->
            <li><router-link class='home' :to="{ name: 'accueil'}" >Rapport*</router-link></li>
            <!--DEVELOPEMENT-->
            <li><a class='prett' href='' title=''>Dev</a><b-icon :icon="'chevron-down'" :variant="getTheme.light" font-scale="0.8"></b-icon>
                <ul class='menus'>
                    <li><router-link class='home' :to="{ name: 'loadedData'}">loaded data</router-link></li>
                    <li><router-link class='home' :to="{ name: 'debugIndex'}">logs d'erreur</router-link></li>
                </ul>
            </li>
            
            <!--<li><router-link class='home' :to="{ name: 'loadedData'}">loadedData</router-link></li>-->

            <li>
                <a class='prett' href='#' title=''>{{getDatabase}}</a><b-icon :icon="'chevron-down'" :variant="getTheme.light" font-scale="0.8"></b-icon>
                <ul class='menus'>
                    <li v-for="(lic, index) in licences" :key="index">
                        <a @click="changeWorkLicence(lic)"><span class='home'>{{ lic }}</span></a>
                    </li>
                </ul>
            </li>

            <!-- <li>
                <a class='prett' href='#' v-capitalize title=''>{{ $gFirstUpper($i18n.locale) }}</a><b-icon :icon="'chevron-down'" :variant="getTheme.light" font-scale="0.8"></b-icon>
                <ul class='menus'>
                    <li><a @click="changeLocale('fr')"><span class='home'>{{$gFirstUpper('Fr') }}</span></a></li>
                    <li><a @click="changeLocale('en')"><span class='home'>{{$gFirstUpper('En') }}</span></a></li>
                </ul>
            </li> -->

            <li>
                <a class='prett' href='#' title=''>{{getUserName}}</a><b-icon :icon="'chevron-down'" :variant="getTheme.light" font-scale="0.8"></b-icon>
                <ul class='menus'>
                    <li><router-link class='home' :to="{ name: 'dashboard'}">Dashboard</router-link></li>
                    <li><a @click.prevent="Logout()"><span class='home'>{{$t('m_Sortir')}}</span></a></li>
                </ul>
            </li>
              
        </ul>


        <!--ICONE TOP-->
        <div v-show="!mobile" class="topIcon">
            <img src="../../../assets/menuIcons/white/help.png">
            <img src="../../../assets/menuIcons/blue/plusRound.png" @click="menuPlusOpen=!menuPlusOpen">
            <img src="../../../assets/menuIcons/white/timer.png">
            <img src="../../../assets/menuIcons/white/checkBox.png">
            <img src="../../../assets/menuIcons/white/bellEmpty.png">
            <img src="../../../assets/menuIcons/white/user.png">
            <img src="../../../assets/menuIcons/white/menuRound.png" @mouseenter="menuOpen=true" @click="menuOpen=!menuOpen">
        </div>

        

<!--FIN - VERSION DESKTOP ================================================================================================================================================================================-->

<!--VERSION MOBILE ================================================================================================================================================================================-->
        <div v-show="mobile" class="branding">
            <img src="../../../assets/logo.png" style="margin-left: 30px; margin-top: 10px;">
            <img src="../../../assets/menuIcons/blue/vLine.png" style="margin-top: 10px;">

            <div class="topIconMobile" style="margin-top: 10px">
                <img src="../../../assets/menuIcons/white/plusRound.png">
                <img src="../../../assets/menuIcons/white/bellEmpty.png">
            </div>

        </div>

        <div class="icon">
            <i @click="toggleMobileNav" v-show="mobile" class="far fa-bars" :class="{'icon-active' : mobileNav}"></i>
        </div>

        <transition name="mobile-nav">

            <ul v-show="mobileNav" class="dropdown-nav">
                
                <div class="menuMobileMain">

                    <!--ICONE TOP-->
                    <div class="topIconMobile2">
                        <img class="topIconMobile2Individual" src="../../../assets/menuIcons/darkblue/help.png">
                        <img class="topIconMobile2Individual" src="../../../assets/menuIcons/darkblue/timer.png">
                        <img class="topIconMobile2Individual" src="../../../assets/menuIcons/darkblue/checkBox.png">
                        <img class="topIconMobile2Individual" src="../../../assets/menuIcons/darkblue/user.png">
                        <img class="topIconMobile2Individual" src="../../../assets/menuIcons/darkblue/menuRound.png">
                    </div>

                    <!--ACCUEIL-->
                    <div class="menuMobile" @click="pushto('/')">{{$t('m_Accueil')}}</div>
                    <!--VENTE-->
                    <div class="menuMobile" @click="allPortbaleMenuOff('visibleVente')">Vente<b-icon :icon="'chevron-right'" :variant="getTheme.dark" font-scale="0.8"></b-icon></div>
                        <b-collapse id="collapse-4" v-model="visibleVente" class="menuMobileSub1"><a @click.prevent="pushto('/sales/invoice')">Factures</a></b-collapse>
                        <b-collapse id="collapse-4" v-model="visibleVente" class="menuMobileSub1">Commande</b-collapse>
                        <b-collapse id="collapse-4" v-model="visibleVente" class="menuMobileSub1">Soumission</b-collapse>
                    <!--CLIENT-->
                    <div class="menuMobile" @click="allPortbaleMenuOff('visibleClient')">Client<b-icon :icon="'chevron-right'" :variant="getTheme.dark" font-scale="0.8"></b-icon></div>
                        <b-collapse id="collapse-4" v-model="visibleClient" class="menuMobileSub1"><a @click.prevent="pushto('/client/clientAccount')">Fiches client</a></b-collapse>
                        <b-collapse id="collapse-4" v-model="visibleClient" class="menuMobileSub1"><a @click.prevent="pushto('/client/contacts')">Contacts</a></b-collapse>
                        <b-collapse id="collapse-4" v-model="visibleClient" class="menuMobileSub1"><a @click.prevent="">Paiements</a></b-collapse>
                        <b-collapse id="collapse-4" v-model="visibleClient" class="menuMobileSub1"><a @click.prevent="">Entente de paiement</a></b-collapse>
                    <!--INVENTAIRE-->
                    <div class="menuMobile" @click="allPortbaleMenuOff('visibleInv')">Inventaire<b-icon :icon="'chevron-right'" :variant="getTheme.dark" font-scale="0.8"></b-icon></div>
                        <b-collapse id="collapse-4" v-model="visibleInv" class="menuMobileSub1"><a @click.prevent="pushto('/inventory/items')">Items</a></b-collapse>
                        <b-collapse id="collapse-4" v-model="visibleInv" class="menuMobileSub1"><a @click.prevent="pushto('/inventory/department')">Départements</a></b-collapse>
                        <b-collapse id="collapse-4" v-model="visibleInv" class="menuMobileSub1"><a @click.prevent="pushto('/inventory/category')">Catégories</a></b-collapse>
                        <b-collapse id="collapse-4" v-model="visibleInv" class="menuMobileSub1">Ajustement</b-collapse>
                    <!--ACHAT-->
                    <div class="menuMobile" @click="allPortbaleMenuOff('visibleAchat')">Achat<b-icon :icon="'chevron-right'" :variant="getTheme.dark" font-scale="0.8"></b-icon></div>
                        <b-collapse id="collapse-4" v-model="visibleAchat" class="menuMobileSub1">Achats</b-collapse>
                        <b-collapse id="collapse-4" v-model="visibleAchat" class="menuMobileSub1">Réceptions</b-collapse>
                    <!--FOURNISSEUR-->
                    <div class="menuMobile" @click="allPortbaleMenuOff('visibleFournisseur')">Fournisseur<b-icon :icon="'chevron-right'" :variant="getTheme.dark" font-scale="0.8"></b-icon></div>
                        <b-collapse id="collapse-4" v-model="visibleFournisseur" class="menuMobileSub1"><a @click.prevent="pushto('/supplier/suppliers')">Fournisseurs</a></b-collapse>
                        <b-collapse id="collapse-4" v-model="visibleFournisseur" class="menuMobileSub1"><a @click.prevent="pushto('/supplier/contacts')">Contacts</a></b-collapse>
                        <b-collapse id="collapse-4" v-model="visibleFournisseur" class="menuMobileSub1">Paiements</b-collapse>
                    <!--COMPTABILITÉ-->
                    <div class="menuMobile" @click="allPortbaleMenuOff('visibleComptabilite')">Comptabilité<b-icon :icon="'chevron-right'" :variant="getTheme.dark" font-scale="0.8"></b-icon></div>
                        <b-collapse id="collapse-4" v-model="visibleComptabilite" class="menuMobileSub1">Comptes</b-collapse>
                        <b-collapse id="collapse-4" v-model="visibleComptabilite" class="menuMobileSub1">Exercices</b-collapse>
                        <b-collapse id="collapse-4" v-model="visibleComptabilite" class="menuMobileSub1">Transaction</b-collapse>
                        <b-collapse id="collapse-4" v-model="visibleComptabilite" class="menuMobileSub1">Conciliations</b-collapse>
                        <b-collapse id="collapse-4" v-model="visibleComptabilite" class="menuMobileSub1">Chèques</b-collapse>
                    <!--RAPPORTS-->
                    <div class="menuMobile" @click="pushto('/')">Rapports</div>
                    <!--LICENCES-->
                    <div class="menuMobile" @click="allPortbaleMenuOff('visibleLicence')">{{getDatabase}}<b-icon :icon="'chevron-right'" :variant="getTheme.dark" font-scale="0.8"></b-icon></div>
                    <b-collapse id="collapse-4" v-for="(lic, index) in licences" :key="index" v-model="visibleLicence" class="menuMobileSub1">
                        <a @click="changeWorkLicence(lic)"><span class='home'>{{ lic }}</span></a>
                    </b-collapse>
                    <!--LOCALE-->
                    <div class="menuMobile" @click="allPortbaleMenuOff('visibleLocale')">{{$i18n.locale}}<b-icon :icon="'chevron-right'" :variant="getTheme.dark" font-scale="0.8"></b-icon></div>
                    <b-collapse id="collapse-4" v-model="visibleLocale" class="menuMobileSub1"><a @click="changeLocale('fr')"><span class='home'>Fr</span></a></b-collapse>
                    <b-collapse id="collapse-4" v-model="visibleLocale" class="menuMobileSub1"><a @click="changeLocale('en')"><span class='home'>En</span></a></b-collapse>

                    <!--USER-->
                    <div class="menuMobile" @click="allPortbaleMenuOff('visibleUser')">{{getUserName}}<b-icon :icon="'chevron-right'" :variant="getTheme.dark" font-scale="0.8"></b-icon></div>
                    <b-collapse id="collapse-4" v-model="visibleUser" class="menuMobileSub1"><a @click.prevent="pushto('/dashboard')"><span class='home'>Dashboard</span></a></b-collapse>
                    <b-collapse id="collapse-4" v-model="visibleUser" class="menuMobileSub1"><a @click.prevent="Logout()"><span class='home'>{{$t('m_Sortir')}}</span></a></b-collapse>


                </div>
            </ul>
        </transition>

<!--FIN - VERSION MOBILE ================================================================================================================================================================================-->

    </nav>

<!--MENU PLUS-->
<div v-show="menuPlusOpen" class="whiteBack"></div>
<div v-show="menuPlusOpen" class="modulePlusMenu">
    Facture<br>
    Client<br>
    Soumission<br>
    Écriture<br>
    Shtroumph<br>
    Fournisseurs<br>
    Rapports<br>
</div>
<!--FIN - MENU PLUS-->

<!--MENU MODULE-->
<div v-show="menuOpen" class="whiteBack" @mouseleave="menuOpen=false"></div>
<div v-show="menuOpen" class="modulePageMenu">

    <div class="h-100 container">
        <div class="row" style="height: 50px;">
            <div class="col-10">
                
            </div>
            <div class="col">
                <div class="d-flex w-100 flex-row-reverse flex-nowrap overflow-visible" style="width:100%;position: absolute;top: 0;right: 0;">
                    <div class="py-2 px-3"><a @click="changeLocale('fr')"><span class='lang' :class="{'active' : $gFirstUpper($i18n.locale) == 'Fr' }">{{$gFirstUpper('Fr') }}</span></a></div>
                    <div class="py-2 px-3"><a @click="changeLocale('en')"><span class='lang' :class="{'active' : $gFirstUpper($i18n.locale) == 'En' }">{{$gFirstUpper('En') }}</span></a></div>
                </div>
            </div>
        </div>
        <div class="row" style="height: calc(100% - 50px);">
            <div class="col-5">
                
            </div>
            <div class="col-7">

            </div>
        </div>
    </div>
</div>
<!--FIN - MENU MODULE-->

  </header>
</template>

<script>

import {mapGetters} from 'vuex'
import mobileNav from '../../../mixins/mobileNav.js'
import {userService} from '@/services'

export default {
    name: "s-navigation",
    mixins:[mobileNav],
    data() {
        return {
            licence: [],
            scrollNav: null,
            mobile: null,
            mobileNav: null,
            menuOpen: false,
            menuPlusOpen: false,
            visibleVente: false,
            visibleClient: false,
            visibleInv: false,
            visibleAchat: false,
            visibleFournisseur: false,
            visibleComptabilite: false,
            visibleLicence: false,
            visibleLocale: false,
            visibleUser : false,
            allSize:{
                saveMenuHeight: 'saveMenuHeightSM',
                pagePadTop: 'pagePadTopSM',
                buttonMenu: 'sm',
                buttonItemList: 'sm',
                pagination: 'sm'
    }

        }
    },
    mounted() {
        window.addEventListener("scroll", this.updateScroll);

        /*
        alert(window.innerWidth+'   '+window.innerHeight);
        //----------
        //this.createLicence() //charger les licences
        this.$store.commit('changeScreenSizeW', window.innerWidth)
        this.$store.commit('changeScreenSizeH', window.innerHeight)
        */
    },
    methods: {
        changeWorkLicence(licence){
            userService.updateLicence(licence)
            this.$nextTick(() => {
                location.reload()
            })
        },
        changeLocale(locale) {
            this.$i18n.locale = locale
            userService.updateLocale(locale);
        },
        allPortbaleMenuOff(from){
            if(from == 'visibleVente'){this.visibleVente = !this.visibleVente}else{this.visibleVente = false}
            if(from == 'visibleClient'){this.visibleClient = !this.visibleClient}else{this.visibleClient = false}
            if(from == 'visibleInv'){this.visibleInv = !this.visibleInv}else{this.visibleInv = false}
            if(from == 'visibleAchat'){this.visibleAchat = !this.visibleAchat}else{this.visibleAchat = false}
            if(from == 'visibleFournisseur'){this.visibleFournisseur = !this.visibleFournisseur}else{this.visibleFournisseur = false}
            if(from == 'visibleComptabilite'){this.visibleComptabilite = !this.visibleComptabilite}else{this.visibleComptabilite = false}
            if(from == 'visibleLicence'){this.visibleLicence = !this.visibleLicence}else{this.visibleLicence = false}
            if(from == 'visibleLocale'){this.visibleLocale = !this.visibleLocale}else{this.visibleLocale = false}
            if(from == 'visibleUser'){this.visibleUser = !this.visibleUser}else{this.visibleUser = false}
        },
        pushto(link) {
            this.mobileNav = false
            //this.mobile = false
            this.$router.push(link)
        },

        changeAllSize(size) {
            if (size == 'sm')
            {
                this.allSize.saveMenuHeight = 'saveMenuHeightSM'
                this.allSize.pagePadTop = 'pagePadTopSM'
                this.allSize.buttonMenu = 'sm'
                this.allSize.buttonItemList = 'sm'
                this.pagination = 'sm'
            }

            if (size == 'md')
            {
                this.allSize.saveMenuHeight = 'saveMenuHeightMD'
                this.allSize.pagePadTop = 'pagePadTopMD'
                this.allSize.buttonMenu = 'md'
                this.allSize.buttonItemList = 'sm'
                this.pagination = 'sm'
            }

            if (size == 'lg')
            {
                this.allSize.saveMenuHeight = 'saveMenuHeightLG'
                this.allSize.pagePadTop = 'pagePadTopLG'
                this.allSize.buttonMenu = 'lg'
                this.allSize.buttonItemList = 'sm'
                this.pagination = 'sm'
            }
            this.$store.commit('changeAllSize', this.allSize)
        },
        updateScroll(){
            const scrollPosition = window.scrollY;
            if (scrollPosition > 50)
                {
                    this.scrollNav = true;
                    return;
                }
            this.scrollNav = false
        },
        Logout(){
           userService.logout();
           this.$router.push('/login')
        },
    },
    computed: {
        ...mapGetters(['getTheme', 'getUser', 'getworkLicence', 'getScreenSize', 'getTaxes', 'getActiveTaxes','getDatabase', 'getUserName','getLicences']),
        licences : () => userService.getUserLicences()
    },
};
</script>

<style lang="scss" scoped>
//@import './s-navigationCss.scss';
@import './s-submenu.scss';
@import './s-navigationModulePages.scss';
@import './s-submenu_mobile.scss';
</style>
